import {NavLink} from "react-router-dom";
import React from "react";

export default function MenuNavLink({name = '', to = ''}) {
  return (
    <li className='nav-item'>
      <NavLink to={to} className='nav-link'>{name}</NavLink>
    </li>
  );
}